<template>
  <elastic-dialog
    v-if="layout"
    :header="dialogOption.header"
    :disabledApplyBtn="!isValid"
    :applyBtnName="dialogOption.applyBtnName"
    :cancelBtnName="dialogOption.cancelBtnName"
    :footerText="errors.join(',')"
    :footerTextStyle="{color:'red'}"
    @apply="applyHandler"
    @cancel="$emit('cancel',model)">
    <vue-json-layout
      :layout="layout"
      :model="model"
    ></vue-json-layout>
  </elastic-dialog>
</template>

<script>
  import ElasticDialog from '@/components/basic/elastic-dialog'
  import VueJsonLayout from "@/components/vue-json-layout/vue-json-layout"
  import {debounce,isString,isObject} from 'lodash'
  import jsonPointer from '@/utils/jsonPointer'
  import localize_ru from'ajv-i18n/localize/ru'

  export default {
    name: "schema-dialog",
    props:{
      hyperSchema:[Object,String],
      initModel:{
        type:Object,
        default:()=>({})
      },
      dialogOption:{
        type:Object ,
        default:()=>({
          header:"",
          applyBtnName:"Apply",
          cancelBtnName:"Cancel"
        })
      },
      layoutOption:{
        type:Object,
        default:()=>({})
      },
      actionLink:String,//Create or Update or Undefine
    },
    created(){
      this.$jsonSchemeUtils.checkOnLoadHyperSchema(this.hyperSchema).then(hyperSchema=>{
        this.fullHyperSchema=hyperSchema;
        const submissionSchema = (this.actionLink?this.fullHyperSchema.links[this.actionLink].submissionSchema:this.fullHyperSchema) || hyperSchema;
        this.submissionSchema = submissionSchema.$ref?jsonPointer.get(this.fullHyperSchema,submissionSchema.$ref):submissionSchema;
        this.layout=this.$jsonSchemeUtils.generateJsonLayoutByScheme(this.submissionSchema,this.model,this.layoutOption);
        //console.log(JSON.stringify(this.layout,null,2))
        this.validate();
      })
    },
    data(){
      return {
        errors:[],
        isValid:false,
        layout:null,
        fullHyperSchema:null,
        submissionSchema:null,
        model:this.initModel||{},//props может быть не реактивен, если не копировать объект то props также будет меняться

      }
    },
    watch:{
      model:{
        handler(){
          this.isValid=false;
          this.validate();
        },
        deep:true
      }
    },
    methods:{
      validate:debounce(function(){
        this.isValid = this.$ajv.validate(this.submissionSchema, this.model);
        if (!this.isValid){
          localize_ru(this.$ajv.errors)
          this.errors=this.$ajv.errors.map(i=>this.customizeErrorMassage(i))
        }else{
          this.errors=[]
        }

        //console.log(this.$ajv.errors);
        this.isValid = this.errors.length==0
        //this.isValid=true;
      },500),
      applyHandler(){
        if (this.actionLink){
          Vue.axios({
            method: this.fullHyperSchema.links[this.actionLink].method,
            url: this.fullHyperSchema.base,
            data:this.model
          }).catch(e=>console.log(e))
        }
        this.$emit('apply',this.model) ;
      },
      customizeErrorMassage(error){
        if (error.keyword=="required"&&error.parentSchema.properties){
          const prop = error.parentSchema.properties[error.params.missingProperty[0]=='.'?error.params.missingProperty.substr(1):error.params.missingProperty]
          return  error.parentSchema.title+": "+error.message.replace(error.params.missingProperty,"\""+prop.title+"\"");
        }
        let message = error.parentSchema.title+": "+error.message;
        return message.replace("integer","целое число")
      }
    },
    components:{ElasticDialog,VueJsonLayout},

  }
</script>

<style scoped>

</style>
